var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"countdown"},[_vm._v(_vm._s((_vm.day>0?_vm.day+_vm.txt[0]+' ':'')+ _vm.hr+_vm.txt[1]+' ' +_vm.min+_vm.txt[2]+' '+ _vm.sec+_vm.txt[3]))])
}
var staticRenderFns = []

export { render, staticRenderFns }